<template>
  <div :class="$style.noItems">
    <h2 v-if="title || icon">
      <SCALoader v-if="loading" size="small" />
      <SCASvgIcon v-if="!loading && icon" :icon="icon" size="16px" />
      <span v-if="title">{{ title }}</span>
    </h2>
    <slot />
  </div>
</template>
<script setup lang="ts">
import type { IconName } from "../icons/iconNames.generated";
import SCALoader from "../SCALoader.vue";
import SCASvgIcon from "../SCASvgIcon.vue";

withDefaults(
  defineProps<{
    title?: string;
    icon?: IconName | null;
    loading?: boolean;
  }>(),
  {
    title: "No items",
    icon: "phosphor/list-bullets",
    loading: false,
  },
);
</script>
<style module lang="scss">
@use "../../styles/generated/figma_typo_mixins.scss" as FigmaTypoMixins;

.noItems {
  @include FigmaTypoMixins.typo-body-medium;
  padding: var(--space-component-padding-xLarge) 0;
  width: 100%;
  display: flex;
  gap: var(--space-component-padding-medium) var(--space-component-padding-small);
  flex-direction: column;
  align-items: center;
  white-space: nowrap;

  h2 {
    @include FigmaTypoMixins.typo-body-medium;
    display: flex;
    border: none;
    max-width: 100%;
    justify-content: center;
    align-items: center;
    gap: var(--space-component-gap-small);
    white-space: nowrap;
    span {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
